import { QueryKey as OriginQueryKey, useQuery, UseQueryOptions } from '@tanstack/react-query';

import { QUERY_KEY } from '@query/keys';
import { ApiRepository } from '@repositories/api';

import type {
  GetDailyActiveUsersListRequestPayload,
  DailyActiveUsersListResponseOK,
  DailyActiveUsersListResponseError
} from '@repositories/api/statistics.types';
import type { AxiosResponse } from 'axios';

type Props<Data extends AxiosResponse, ErrorResponse, QueryKey extends OriginQueryKey> = {
  queryParams: GetDailyActiveUsersListRequestPayload['queryParams'];
  options?: Omit<
    UseQueryOptions<Data, ErrorResponse, Data['data']['data'], QueryKey>,
    'queryKey' | 'queryFn' | 'initialData'
  >;
};

function useGetDailyActiveUsersListQuery<
  Data extends DailyActiveUsersListResponseOK,
  ErrorResponse extends DailyActiveUsersListResponseError
>({
  queryParams,
  options
}: Props<
  Data,
  ErrorResponse,
  ReturnType<typeof QUERY_KEY.STATISTICS.GET_DAILY_ACTIVE_USERS_LIST>
>) {
  return useQuery({
    queryKey: QUERY_KEY.STATISTICS.GET_DAILY_ACTIVE_USERS_LIST({ queryParams }),
    queryFn: () => {
      return ApiRepository.statistics.getDailyActiveUsersList({ queryParams });
    },
    select: (data) => data.data.data,
    ...options
  });
}

export { useGetDailyActiveUsersListQuery };
